/*
 * Title: SignedOutRedeemPage.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import RedeemTab component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React, { Fragment } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CallbackService from "@services/callback-service";
import { Dialog, Transition } from "@headlessui/react";
import { useSelector } from "react-redux";
import EarnContentTile from "@components/Rewards/EarnContentTile";
import gif from "@assets/gif.gif";
import check from "@assets/check.png";
import close from "@assets/close.png";
import Logo from "@components/Logo";
import Loader from "@components/Loader";

type Props = {};

const ScannerEventPage: React.FC<Props> = (props) => {
  const { search } = useLocation();
  const { cname, pname } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = React.useState(false);
  const [isRedirect, setIsRedirect] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [data, setData] = React.useState<any>({});
  const params = new URLSearchParams(search);
  const id = params.get("id");
  const seed = params.get("seed");
  const eventId = params.get("eventId");
  let redirectUrl = params.get("redirectUrl");

  const user = useSelector((state: any) => state.user);
  const creator = useSelector((state: any) => state.creator);
  const token = user?.user?.token;

  React.useEffect(() => {
    let data = {
      id: id,
      seed: seed,
      eventId: eventId,
    };
    if (redirectUrl) {
      data["redirectUrl"] = redirectUrl;
    }

    if (id && seed && eventId) {
      CallbackService.setScannerEventPayload(data);
    }

    const callWebhook = async () => {
      if (token) {
        if (id && seed && eventId) {
          const data = {
            query: "scanner-event",
            programId: user?.user?.user?.programId,
            creatorId: user?.user?.user?.creatorId,
            fanId: user?.user?.user?.id,
            actionId: id,
            eventId: eventId,
            seed: seed,
          };
          setLoading(true);
          const json = await CallbackService.scannerEventWebhook(data);
          setLoading(false);
          if (json.status == 200) {
            setData(json.data?.score || {});
            setStatus(true);
            if (redirectUrl) {
              setIsRedirect(true);
              const timer = setTimeout(() => {
                setStatus(false);
                if (!/^https?:\/\//i.test(redirectUrl)) {
                  redirectUrl = `https://${redirectUrl}`; // Add "http://" if it's not already there
                }
                window.location.href = redirectUrl;
              }, 3000);
              return () => clearTimeout(timer);
            } else {
              const timer = setTimeout(() => {
                setStatus(false);
                navigate(
                  `/${creator.creator?.username}/${creator.program?.name}`
                );
              }, 3000);
              return () => clearTimeout(timer);
            }
          } else {
            setStatus(true);
            setError(json?.data?.message);
            const timer = setTimeout(() => {
              setStatus(false);
              navigate(
                `/${creator.creator?.username}/${creator.program?.name}`
              );
            }, 3000);
            return () => clearTimeout(timer);
          }
        }
      } else {
        navigate(`/${cname}/${pname}`);
      }
    };

    const timer = setTimeout(() => {
      callWebhook();
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  return <>{loading && <Loader height={30} width={30} white={false} />}</>;
};

export default ScannerEventPage;
